import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { Subject } from 'rxjs/Rx'
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { AppraisalService } from '../services/appraisal.service';
import { LoginService } from '../services/login.service'
import {MatTableDataSource} from '@angular/material';

@Component({
  selector: 'app-nus-list-l3',
  templateUrl: './nus-list-l3.component.html',
  styleUrls: ['./nus-list-l3.component.css']
})
export class NusListL3Component implements OnInit {

   users;
   self_code;
  nus_msg = '';
  appraisalData=[];
  appraisal_msg;
  appraisal_year;
  parti_appraisal_year = null;
  dataTable: any;
  
 
  constructor( private apprais : AppraisalService, public ls : LoginService, private chRef: ChangeDetectorRef) { 
   // this.getUserList();
    this.getUserList(this.parti_appraisal_year);
  }

  ngOnInit() {
    this.self_code = this.ls.employeeCode;
    this.nus_msg = localStorage.getItem('nus_msg');
    localStorage.removeItem('nus_msg');
    
   
  }
  getUserList(parti_appraisal_year)
  {
    this.appraisalData = new Array<any>();
    var users = this.apprais.getNSUUser(parti_appraisal_year).subscribe( res => {
      this.users = res.users;
      this.appraisal_year = res.appraisal_year;
      this.parti_appraisal_year = res.parti_appraisal_year;
      this.chRef.detectChanges();
      const table: any = $('#example');
      
      this.dataTable = table.DataTable();
    
  })
     
  }

  onSubmit(assignAppraisalYear)
  {
    
   //alert('hi');
     console.log(this.parti_appraisal_year);
     this.dataTable.destroy();
    this.getUserList(this.parti_appraisal_year);

    //this.router.navigate(['/selfAppraisalAssign']);
    
      
   
   
  }

}



// WEBPACK FOOTER //
// ./src/app/nus-list-l3/nus-list-l3.component.ts